export default {
  // 主導航菜單
  home: "首頁",
  analysisAndResearch: "研判分析",
  evidenceManagement: "調證管理",
  dataBoard: "數據看板",
  caseToolbox: "辦案工具箱",
  helpCenter: "幫助中心",
  apiService: "APIs",
  permissionManagement: "權限管理",

  // 研判分析子菜單
  caseAnalysis: "案件分析",
  balanceAnalysis: "餘額分析",
  labelManagement: "標籤管理",
  aiModel: "AI模型",
  addressMonitoring: "地址監控",
  remarkManagement: "備註管理",

  // 調證管理子菜單
  evidenceAdvice: "調證建議",
  evidenceUsers: "調證用戶",
  evidenceUpload: "調證上傳",
  evidenceInvestigation: "調證協查",

  // 數據看板子菜單
  transactionData: "交易數據",
  balanceData: "餘額數據",

  // 辦案工具箱子菜單
  addressCompletion: "地址補全",
  hashCompletion: "哈希補全",
  tgSentimentAnalysis: "TG公群輿情分析",

  // 幫助中心子菜單
  productFunction: "產品功能介紹",
  judicialReference: "司法判例參考",
  prosecutionBook: "起訴書",
  policyRegulation: "政策法規",
  blockchainKnowledge: "區塊鏈行業知識",
  blockchainCaseInvestigation: "區塊鏈案件偵查實錄",

  // 權限管理子菜單
  labelList: "標籤管理",
  userList: "用戶列表",
  roleManagement: "角色管理",
  userLog: "用戶日誌",
  adminLog: "管理日誌",

  // 其他
  dataLargeScreen: "數據大屏",
  userCenter: "用戶中心",
  userFeedback: "用戶反饋",
  logout: "退出登錄",
};
